import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseTransactionImporterSelectors =
  importerSelectors('courseTransaction.importer')

export default courseTransactionImporterSelectors
